export type Selection = {
    level1: string | null;
    level2: string | null;
    level3: string | null;
    level4: string | null;
};

// Get CSS variable values for chart colors
export const getCssValue = (token: string, fallback: string, element?: Element | null) => {
    if (typeof document === "undefined") {
        return fallback;
    }

    const resolvedElement = element ?? document.documentElement;

    if (!resolvedElement) {
        return fallback;
    }

    return getComputedStyle(resolvedElement).getPropertyValue(token).trim() || fallback;
};

export const getThemeAwareCssValue = (
    lightToken: string,
    darkToken: string,
    fallbackToken = "--ds-color-text-default",
) => {
    if (typeof document === "undefined") {
        return "currentColor";
    }

    const appShellElement = document.querySelector(".app-shell");
    const isDarkMode = appShellElement?.getAttribute("data-color-scheme") === "dark";
    const token = isDarkMode ? darkToken : lightToken;

    return getCssValue(token, getCssValue(fallbackToken, "currentColor", appShellElement), appShellElement);
};
